<template>
  <div id="footer">
    <div class="container-fluid">
       <div class="consultation padTB-a leadSec" id="lead">
        <div class="leadIntro">
          <div class="pageTitle">
            <p>consultation</p>
            <h4>网站定制咨询</h4>
          </div>
          <p class="leadDesc">留下联系方式，建站顾问将尽快与您联系，免费提供建站方案与报价。</p>
          <ul class="leadList">
            <li>一对一顾问，按行业推荐模板</li>
            <li>PC + 手机网站同步生成</li>
            <li>不想填表？直接拨打 <a href="tel:4009209933">400 920 9933</a></li>
          </ul>
        </div>
        <div class="form marT-b">
          <div class="col">
            <input type="text" class="form-control" v-model="form.businesstype" placeholder="公司名称" aria-label="公司名称" autocomplete="organization" />
          </div>
          <div class="col">
            <input type="text" class="form-control" v-model="form.usrname" placeholder="您的姓名(中文)" aria-label="您的姓名" autocomplete="name" />
          </div>
          <div class="col">
            <input type="tel" inputmode="numeric" class="form-control" v-model="form.mobile" placeholder="您的手机号码(11位数字)" aria-label="手机号码" autocomplete="tel" />
          </div>
          <div class="col" style="display:none;">
            <div class="input-group ver">
              <input type="text" class="form-control" v-model="form.smscode" placeholder="验证码" maxlength="4" />
              <a href="javascript:void(0)" class="verBtn" :style="btnStyle" id="opercheckbtn"  v-text="codeBtnText"></a>
            </div>
          </div>
          <div class="sureBtn">
            <button  :disabled="isLoggingIn"  @click="submitForm"  class="sureBtn">
              <span v-if="isLoggingIn" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
              {{ isLoggingIn ? '处理中...' : '提交需求' }} 
            </button>

          </div>
          <p class="leadNote">信息仅用于建站咨询回访，不会公开</p>
        </div>
      </div>
      <div class="tempBot time03">
        <div class="tempBot-wrapper text-center">
          <div class="text">
            <h4 class="time03">会打字就能建网站</h4>
            <h5 class="time03">网站效果即改即现实时感知</h5>
            <h6 class="time03">无需设计满足您的各种需求</h6>
          </div>
          <div class="btn">
            <a href="javascript:" class="mt-0 py-3 px-5 rounded-pill btn btn-primary fs-5 fw-bold" @click="actionFree()">免费建站</a>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid a">
      <footer class="footer padTB-a">
        <p>Copyright © 2006-2017 SiteStar, All Rights Reserved.<span>上海美橙科技信息发展有限公司</span></p>
        <p><a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备11006888号-4 上海美橙科技信息发展有限公司</a></p>
      </footer>
    </div>
  </div>
</template>

<script>
import { getSmsCode, getToken,feedbackSubmit,Customdrag_URL } from '@/api/user';
import uhiddenUtil from '@/utils/uhiddenUtil';
import qs from 'qs'
import deviceMixin from '@/mixins/device';


let globalVM = null;

export default {
  mixins: [deviceMixin],
  data() {
    return {
      form: {
        businesstype: '',
        usrname: '',
        mobile: '',
        smscode: ''
      },
      uhidden: '',
      fmtoken: '',
      customdragurl: Customdrag_URL,
      codeBtnText: '获取验证码',
      isSendingCode: false,
      isLoggingIn: false,     
      ischeckphone: false,   
      timer: null,
      seconds: 60
    };
  },

  computed: {
    btnStyle() {
      return {
        backgroundColor: this.isSendingCode ? '#dcdcdb' : '#007bff',
        cursor: this.isSendingCode ? 'not-allowed' : 'pointer',
        color: this.isSendingCode ? '#999' : '#fff',
        padding: '6px 12px',
        borderRadius: '4px'
      };
    }
  },
   mounted() { 
    globalVM = this;
      this.$nextTick(() => {
        this.initPicsumcaptcha();
      })
   },
  methods: {
     async loadToken() {
      try {
        const uhidden = uhiddenUtil.getSystemCookieId();         
        const res = await getToken(uhidden);
        if (res.data.code === '10000') {
          window.sysmtoken = res.data.message
        } else {      
          this.error = res.data.message;
        }
      } catch (err) {
        this.error = '获取token失败异常';
      }
    },
    validateForm(isCodeSend = false) {
      const { usrname, mobile, smscode, businesstype } = this.form;

      if (!businesstype) return alert('请填写公司名称');
      if (!usrname) return alert('请填写您的姓名');
      if (!mobile) return alert('请填写联系电话');
      if (mobile.length !== 11) return alert('请填写正确手机号');
     // if (!isCodeSend && !this.ischeckphone) return alert('请先获取手机验证码');
      //if (!isCodeSend && !smscode) return alert('请填写手机验证码');

      return true;
    },

    initPicsumcaptcha(){

     try {
        $("#opercheckbtn").picsumcaptcha({
          posturl: globalVM.customdragurl,
          timeout: 80000,
          beforeSend: function () {
             return globalVM.validateForm(true);
          },
          onSuccess: function (res) {
            if (res.message == "10000") {
              globalVM.resendCode();
            } else {
              alert("验证失败，请重新尝试！");
            }
          },
          onError: function () {
            alert("验证失败，请重新尝试！");
          }
        })
      } catch (e) {
        console.info("picsumcaptcha 加载异常");
      }

    },

    async submitForm() {
      if (!this.validateForm()) return;

      try {
        this.isLoggingIn=true;
        this.uhidden=uhiddenUtil.getSystemCookieId();
        const res = await feedbackSubmit(
          this.form.mobile,
          this.form.smscode,
          this.form.businesstype,
          this.form.usrname,
          this.uhidden,
          window.sysmtoken
          );
        
        //console.log('submitForm response:', res);
        this.isLoggingIn=false;
        this.loadToken();
          if (res.data.code === '10000') {
          this.form = { usrname: '', mobile: '', smscode: '', businesstype: '' };
          alert('提交成功!');
        } else {
          alert('提交失败');
        }
      } catch (error) {
        console.error('提交异常:', error);
        alert('提交失败，请稍后再试');
      }
    },


    async resendCode() {
      if (this.isSendingCode || !this.validateForm(true)) return;

      this.isSendingCode = true;
    

      try {
           this.uhidden=uhiddenUtil.getSystemCookieId();
           const res = await getSmsCode(this.form.mobile,this.uhidden);    

        if (res.data.code === '10000') {
          this.ischeckphone=true;
          this.startTimer();
        } else {
          alert('获取验证码失败');
          this.isSendingCode = false;
        }
      } catch (err) {
        console.error('请求错误:', err);
        alert('网络异常，请稍后再试');
        this.isSendingCode = false;
      }
    },


    startTimer() {
      this.seconds = 60;
      this.updateBtnText();
      this.timer = setInterval(() => {
        this.seconds--;
        this.updateBtnText();
        if (this.seconds <= 0) {
          clearInterval(this.timer);
          this.isSendingCode = false;
          this.codeBtnText = '获取验证码';
        }
      }, 1000);
    },

    updateBtnText() {
      this.codeBtnText = `${this.seconds}秒后,可重新获取`;
    },

    goToRegister() {
      const b = sessionStorage.getItem('param_b');
      const targetUrl = b ? `https://www.sitestar.cn/member/register.aspx?b=${encodeURIComponent(b)}` 
                          : 'https://www.sitestar.cn/member/register.aspx';
      window.location.href = targetUrl;
    },
    actionFree(){
       this.$router.push({ path: '/templates', query: { serviceType:'free'} })
    }
  },
  beforeDestroy() {
    globalVM = null;
    if (this.timer) clearInterval(this.timer);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .consultation .form{ border-radius: 10px; padding: 3rem; width: 100%; max-width: 800px; margin-left:auto; margin-right: auto; box-shadow: 5px 5px 15px rgba(0, 0, 0, .16);}
  .consultation .col{border-bottom: 1px solid #D8D8D8; margin-bottom: 15px; }
  .consultation .form-control{ color: #000; flex: 1; width: 100%; border: 0;  height: 70px; padding: 10px; font-size: 15px;}
  .consultation .sureBtn{ margin-top: 1.5rem;}
  .consultation .sureBtn button{ border: 0; width: 100%; display: block; line-height: 56px; border-radius: 5px; background-color: #008AFF; color: #fff; font-size: 15px; padding: 0 10px; text-align: center;}
  .consultation .input-group{display: flex; align-items: center;}
  .consultation .verBtn{ padding: 0 10px; color: #008AFF;}
  .consultation .verBtn:hover{ opacity: .9;}


  @media screen and (max-width: 767px){
    .consultation .form{ padding: 1rem 2rem 2rem 2rem;}
    .consultation .form-control{ height: 60px;}
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue